import { z } from 'zod';
import { ValidationError } from './errors/index.js';
import { Injection } from './injection/Injection.js';
import { Result } from './result/Result.js';
/**
 * Serialization-layer Zod schema validating journal IDs. Xero emits GUIDs
 * in practice, but the schema only checks character class — letters,
 * digits, hyphens, and underscores — so that synthetic identifiers used
 * by test fixtures and ad-hoc tooling don't have to fabricate GUIDs.
 * The character class is tight enough to reject whitespace, quotes, or
 * other ledger-corrupting content.
 */
export const JournalIdSchema = z
    .string()
    .min(1, 'JournalId must not be empty')
    .regex(/^[A-Za-z0-9_-]+$/, 'JournalId must contain only letters, digits, underscores, or hyphens')
    .brand('JournalId');
const journalIdBrand = Injection.brand();
/**
 * Injection between the Flavor-branded `JournalId` domain type and plain
 * `string`. `apply()` strips the brand; `invert()` validates via
 * `JournalIdSchema` and re-brands.
 */
export const journalIdInjection = new Injection((id) => journalIdBrand.apply(id), (s) => {
    const result = JournalIdSchema.safeParse(s);
    if (!result.success) {
        return Result.error(new ValidationError(`Invalid JournalId: ${s}`));
    }
    return journalIdBrand.invert(result.data);
});
//# sourceMappingURL=JournalRelatedTypes.js.map